import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useGetPermissionsQuery, useGiveUserPermissionsMutation } from '../../redux/Slices/permissionsApi';
import Button from '../styled-component/ReusableButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const EnvokePermission = ({ user }) => {
  const { data: Permissions, error, isLoading } = useGetPermissionsQuery();
  console.log("🚀 ~ EnvokePermission ~ Permissions:", Permissions);
  const [giveUserPermissions, { isLoading: isSubmitting }] = useGiveUserPermissionsMutation();
  const [formData, setFormData] = useState({
    user_id: user?.id || '',
    permissions: [],
  });
  const [collapsedSections, setCollapsedSections] = useState({});

  const handlePermissionChange = (permission) => {
    setFormData((prev) => {
      const permissions = prev.permissions.includes(permission)
        ? prev.permissions.filter((p) => p !== permission)
        : [...prev.permissions, permission];
      return { ...prev, permissions };
    });
  };

  const toggleCollapse = (category) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await giveUserPermissions(formData).unwrap();
      console.log("🚀 ~ handleSubmit ~ res:", res);
      alert('Permissions assigned successfully!');
      setFormData({ user_id: user?.id || '', permissions: [] });
    } catch (err) {
      alert('Failed to assign permissions: ' + err.message);
    }
  };

  if (isLoading) return <div className="text-center mt-8">Loading...</div>;
  if (error) return <div className="text-center mt-8 text-red-500">Error: {error.message}</div>;

  return (
    <div className="mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6"> الصلاحيات</h1>
      <Box>
        {Object.entries(Permissions?.data || {}).map(([category, permissions]) => (
          <div key={category} className="grid grid-cols-1 gap-4 mb-6">
            <h2
              className="text-sm font-semibold capitalize cursor-pointer flex items-center"
              onClick={() => toggleCollapse(category)}
            >
              {category}
             
            </h2>
            {!collapsedSections[category] && (
              <div className="flex mt-2" style={{ display: 'flex', flexWrap: 'wrap' , gap: '12px 16px' }}>
                {permissions.map((permission) => (
                  <label 
                    key={permission} 
                    className="cursor-pointer" 
                    style={{
                      display: 'flex', 
                      flex: '0 0 calc(50% - 8px)',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={formData.permissions.includes(permission)}
                      onChange={() => handlePermissionChange(permission)}
                      className="custom-checkbox"
                    />
                    <span className="text-sm text-white">{permission}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
        <Box my={2} display="flex" justifyContent="flex-end" alignItems="center">
        <Button
          type="submit"
          variant="primary"
          mt={2}
          disabled={isSubmitting}
          style={{ marginLeft: '16px' }}
          onClick={handleSubmit}
        >
          {isSubmitting ? 'جاري الحفظ...' : 'حفظ التغييرات'}
        </Button>
        </Box>
      </Box>
      
      <style dangerouslySetInnerHTML={{
        __html: `
          .custom-checkbox {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            width: 18px;
            height: 18px;
            border: 2px solid #d1d5db;
            border-radius: 3px;
            
            cursor: pointer;
            position: relative;
            transition: all 0.2s ease;
          }
          
          .custom-checkbox:checked {
            background-color: #ca9937;
            border-color: #ca9937;
          }
          
          .custom-checkbox:checked::after {
            content: '✓';
            position: absolute;
            top: -3px;
            left: 2px;
            color: white;
            font-size: 14px;
            font-weight: bold;
            line-height: 1;
          }
          
          .custom-checkbox:hover {
            border-color: #ca9937;
            box-shadow: 0 0 5px rgba(202, 153, 55, 0.3);
          }
        `
      }} />
    </div>
  );
};

export default EnvokePermission;